<span class="width info-text">{{infoMessage}}</span>
<mat-progress-bar mode="determinate" [value]="value1" class="width"></mat-progress-bar>